import React from 'react'

import { Grid } from '@mui/material'

import BillingSummary from './CampaignCurrentPeriodSummary'
import CampaignSubscriptionSummary from './CampaignSubscriptionSummary'

const CampaignPayment = () => (
  <Grid container spacing={2}>
    <Grid size={{ sm: 6 }}>
      <CampaignSubscriptionSummary />
    </Grid>
    <Grid size={{ sm: 6 }}>
      <BillingSummary />
    </Grid>
  </Grid>
)

export default CampaignPayment
